import React from "react";
import { Flex, SimpleGrid, Text } from "@chakra-ui/react";
import { LandingPageFeatureSummaryCardType } from "@/features/landing/types";
import useI18nHelper from "@/features/ui/hooks/use-i18n-helper";

const summaryCardList: LandingPageFeatureSummaryCardType[] = [
  {
    title: "summary.brand_title",
    count: "2,157+",
    description: "summary.brand_description",
  },
  {
    title: "summary.member_title",
    count: "421+",
    description: "summary.member_description",
  },
  {
    title: "summary.ai_title",
    count: "146k+",
    description: "summary.ai_description",
  },
  {
    title: "summary.hr_title",
    count: "12y+",
    description: "summary.hr_description",
  },
];

/**
 * 히어로 검정 영역 안에 놓이는 지표 카드 4장.
 * 예전에는 다음 섹션에서 음수 marginTop으로 히어로에 걸쳐놨지만, 개편 시안에서는
 * 히어로 안으로 완전히 들어오므로 위치 보정 없이 그대로 흐른다.
 */
function LandingPageFeatureSummaryCards() {
  return (
    <SimpleGrid
      spacing={{
        base: "16px",
        lg: "20px",
      }}
      columns={{
        base: 1,
        md: 2,
        lg: 4,
      }}
    >
      {summaryCardList.map((summary, index) => (
        <FeatureSummaryCard key={index} summary={summary} />
      ))}
    </SimpleGrid>
  );
}

export default LandingPageFeatureSummaryCards;

interface Props {
  summary: LandingPageFeatureSummaryCardType;
}

function FeatureSummaryCard({ summary }: Props) {
  const { t, tTitle } = useI18nHelper();
  return (
    <Flex
      flexDirection={"column"}
      padding={{
        base: "20px 16px",
        lg: "28px 24px",
      }}
      gap={{
        base: "12px",
        lg: "20px",
      }}
      borderRadius={"16px"}
      boxShadow={"0 8px 32px 0 rgba(0, 0, 0, 0.08)"}
      background={"#FFFFFF"}
      border={"1px solid #E8E8E8"}
    >
      <Flex flexDirection={"column"} gap={"10px"}>
        <Text
          color={"#1272EF"}
          fontSize={"16px"}
          fontWeight={600}
          lineHeight={"24px"}
        >
          {tTitle("landing:" + summary.title)}
        </Text>
        <Text color={"#2A2A2A"} fontSize={"32px"} fontWeight={700}>
          {summary.count}
        </Text>
      </Flex>
      <Text textStyle={"label-md-regular"} color={"#737373"}>
        {t("landing:" + summary.description)}
      </Text>
    </Flex>
  );
}
